export var SAME_MONTH_FORMAT = 'd';
export var SAME_YEAR_FORMAT = 'd MMM';
export var DIFF_YEAR_FORMAT = 'd MMM yyyy';
export var FULL_DATE_FORMAT = 'd MMMM yyyy';
export var MONTH_ONLY_FORMAT = 'MMMM';
export var MONTH_ONLY_FORMAT_SHORT = 'MMM';
export var MONTH_ONLY_FORMAT_DIFF_YEAR = 'MMM yyyy';
export var MONTH_WITH_YEAR = 'MMMM yyyy';
export var FULL_NICE_FORMAT = 'dd-MMM-yyyy';
export var NICE_DATE_TIME = 'd MMMM yyyy h:mm a';
export var ISO_LOCAL_DATE = 'yyyy-MM-dd';
export var ISO_LOCAL_TIME = 'HH:mm:ss';
export var ISO_LOCAL_DATE_TIME = "".concat(ISO_LOCAL_DATE, "'T'").concat(ISO_LOCAL_TIME);
export var ISO_LOCAL_DATE_WITH_SLASHES = 'yyyy/MM/dd';